import { useEffect, useRef } from 'react';

const HeroSection = () => {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        heroRef.current.style.backgroundPositionY = `${window.scrollY * 0.3}px`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToVideo = () => {
    const el = document.getElementById('latest-biscuit');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        ref={heroRef}
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/60d3d7d0aee1bca6a064613583971817.jpg)',
        }}
      />

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      <div className="absolute inset-0 bg-[#111111]/30" />

      {/* Grain texture */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")',
        }}
      />

      {/* Hero Content */}
      <div className="relative z-10 text-center w-full flex flex-col items-center px-6">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-[1px] bg-[#f5a623]" />
          <span className="text-[#f5a623] text-xs font-['Roboto'] font-bold tracking-[4px] uppercase">
            YouTube Channel
          </span>
          <div className="w-12 h-[1px] bg-[#f5a623]" />
        </div>

        {/* Main Headline */}
        <h2
          className="font-['Bebas_Neue'] text-[90px] leading-none tracking-[6px] text-white mb-4 animate-[fadeInUp_0.8s_ease_forwards]"
          style={{ textShadow: '0 0 40px rgba(245,166,35,0.3)' }}
        >
          FIX THINGS.<br />DRINK BEER.
        </h2>

        {/* Sub-headline */}
        <p className="font-['Merriweather'] italic text-[#c4c4c4] text-xl mb-10 max-w-lg leading-relaxed">
          Because you have to fix it for the biscuit.
        </p>

        {/* CTA Button */}
        <a
          href="https://www.youtube.com/@beerafterwork"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="group inline-flex items-center gap-3 bg-[#f5a623] hover:bg-[#d4722e] text-white font-['Roboto'] font-bold text-sm tracking-[2px] uppercase px-8 py-4 rounded-md transition-all duration-300 hover:scale-105 whitespace-nowrap"
          style={{ boxShadow: '0 0 30px rgba(245,166,35,0.3)' }}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-youtube-fill text-base" />
          </div>
          Watch the Latest Fix on YouTube
          <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
            <i className="ri-arrow-right-line text-base" />
          </div>
        </a>

        {/* Stats Bar */}
        <div className="mt-16 flex items-center gap-10">
          {[
            { value: '50K+', label: 'Subscribers' },
            { value: '200+', label: 'Projects Fixed' },
            { value: '150+', label: 'Beers Earned' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-['Bebas_Neue'] text-3xl text-[#f5a623] tracking-widest">{stat.value}</div>
              <div className="text-[#9a9a9a] text-xs font-['Roboto'] tracking-[2px] uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToVideo}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 cursor-pointer flex flex-col items-center gap-2 animate-bounce"
        aria-label="Scroll down"
      >
        <span className="text-[#f5a623]/60 text-xs font-['Roboto'] tracking-[2px] uppercase">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center text-[#f5a623]/60">
          <i className="ri-arrow-down-s-line text-xl" />
        </div>
      </button>
    </section>
  );
};

export default HeroSection;
